import React from "react";

import { CameraListElement } from "../CameraListElement/CameraListElement";

import * as styles from "./cameraList.module.less";

export function CameraList({ items, currency }) {
    return (
        <div className={styles.cameraGrid}>
            {items.map((camera) => (
                <CameraListElement
                    key={camera.id}
                    camera={camera}
                    currency={currency}
                />
            ))}
        </div>
    );
}
